import { type ReactNode } from "react";
import { type LucideIcon } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export const EmptyState = ({ icon: Icon, title, description, action }: EmptyStateProps) => (
  <Card className="border-dashed shadow-none">
    <CardContent className="flex flex-col items-center gap-3 py-12 text-center">
      <span className="inline-flex size-12 items-center justify-center rounded-full bg-muted">
        <Icon className="size-6 text-muted-foreground" aria-hidden="true" />
      </span>
      <p className="font-semibold text-foreground">{title}</p>
      {description && <p className="max-w-md text-muted-foreground text-sm">{description}</p>}
      {action}
    </CardContent>
  </Card>
);
